import cx from 'classnames';
import { forwardRef, Ref, useImperativeHandle, useRef } from 'react';
import { FocusRingStyle, useFocusRingStyle } from '../../../../common/hooks/style/use-focus-ring-style';
import { ButtonProps, ButtonRef } from './button.props';

const ButtonComponent = (props: ButtonProps, ref: Ref<ButtonRef>) => {
  const buttonRef = useRef<HTMLButtonElement>(null);

  const {
    buttonType,
    buttonStyle = 'curved',
    type = 'button',
    disabled = false,
    form,
    fullWidth = false,
    onClick,
    className,
    children,
  } = props;

  const click = () => {
    buttonRef.current?.click();
  };

  useImperativeHandle(ref, () => ({
    click,
  }));

  const focusRingStyles = useFocusRingStyle(FocusRingStyle.Focus);
  const buttonStyles = cx(
    'bc-button bsc:max-sm:p-4 bsc:md:p-2 bsc:dark:bg-mono-light-1 bsc:dark:hover:bg-mono-light-2 bsc:dark:text-mono-dark-1',
    focusRingStyles,
    {
      'bsc:w-full': fullWidth,
      'bc-disabled bsc:bg-gray-3 bsc:text-gray-2 bsc:pointer-events-none': disabled,
      'bsc:bg-primary-1 bsc:text-white bsc:hover:bg-primary-2 bsc:focus:ring-primary-1': buttonType === 'primary',
      'bsc:bg-primary-2 bsc:text-white bsc:hover:bg-primary-3 bsc:focus:ring-primary-2': buttonType === 'secondary',
      'bsc:bg-info bsc:text-white bsc:focus:ring-info': buttonType === 'info',
      'bsc:bg-success bsc:text-white bsc:focus:ring-success': buttonType === 'success',
      'bsc:bg-warning bsc:text-white bsc:focus:ring-warning': buttonType === 'warning',
      'bsc:bg-error bsc:text-white bsc:focus:ring-error': buttonType === 'error',
      'bsc:rounded-md': buttonStyle === 'curved',
      'bsc:rounded-full bsc:px-4!': buttonStyle === 'round',
    },
    className,
  );

  return (
    <button ref={buttonRef} type={type} onClick={onClick} disabled={disabled} form={form} className={buttonStyles}>
      {children}
    </button>
  );
};

const Button = forwardRef(ButtonComponent);

export { Button };
